import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-sunrise-orange text-white hover:bg-sunrise-orange-dark focus:ring-sunrise-orange',
    secondary: 'bg-sunrise-brown text-white hover:bg-sunrise-brown-light focus:ring-sunrise-brown',
    outline: 'border-2 border-sunrise-orange text-sunrise-orange hover:bg-sunrise-orange hover:text-white focus:ring-sunrise-orange',
    ghost: 'text-sunrise-charcoal hover:bg-sunrise-cream-dark focus:ring-sunrise-charcoal'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} {...props} data-id="element-182">
      {children}
    </button>;
}